import styled from '@emotion/styled';
import { media } from '@portalterreno/react-ui-core/Grid';
import { HTMLAttributes } from 'react';

export type FeatureListProps = HTMLAttributes<HTMLDivElement>;

const FeatureList = styled('div')<FeatureListProps>({
  display: 'flex',
  flexWrap: 'wrap',
  marginTop: 20,
  [media('xs')]: {
    gap: 38,
    flexDirection: 'column'
  },
  [media('lg')]: {
    gap: 52,
    flexDirection: 'row'
  }
});

export default FeatureList;
